import React, { useState } from "react";
import Reveal from "@/components/Reveal";
import ProjectCard from "@/components/ProjectCard";
import Seo from "@/components/Seo";
import { PROJECTS } from "@/data/site";
import { SEO } from "@/data/seo";
import { useLang } from "@/context/LanguageContext";

const Proyectos = () => {
  const { t } = useLang();
  const [filter, setFilter] = useState("all");

  const filters = [
    { id: "all", label: { es: "Todos", en: "All" } },
    { id: "marketing", label: { es: "Marketing & Eventos", en: "Marketing & Events" } },
    { id: "audiovisual", label: { es: "Audiovisual", en: "Audiovisual" } },
  ];

  const list = filter === "all" ? PROJECTS : PROJECTS.filter((p) => p.branch === filter);

  return (
    <div data-testid="proyectos-page" className="pt-[72px]">
      <Seo {...SEO.proyectos} />
      <section className="max-w-7xl mx-auto px-6 pt-20 md:pt-28">
        <Reveal>
          <span className="font-display text-xs font-bold uppercase tracking-[0.3em] text-brand-gold">{t({ es: "Portfolio", en: "Portfolio" })}</span>
          <h1 className="mt-6 font-display text-5xl md:text-7xl font-black text-white leading-none">
            {t({ es: "Proyectos", en: "Work" })}
          </h1>
          <p className="mt-6 max-w-2xl text-white/60 font-body text-lg">
            {t({ es: "Una selección de nuestro trabajo en las dos ramas de la agencia.", en: "A selection of our work across both sides of the agency." })}
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 flex flex-wrap gap-3">
            {filters.map((f) => (
              <button
                key={f.id}
                onClick={() => setFilter(f.id)}
                data-testid={`filter-${f.id}`}
                className={`rounded-full px-5 py-2.5 font-display text-xs font-bold uppercase tracking-widest transition-colors ${
                  filter === f.id ? "bg-white text-ink" : "bg-white/5 text-white/60 hover:text-white border border-white/10"
                }`}
              >
                {t(f.label)}
              </button>
            ))}
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 auto-rows-[minmax(320px,auto)]">
          {list.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.06} className={p.span || "lg:col-span-6"}>
              <ProjectCard project={p} className="h-full" />
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Proyectos;
